// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".step--done[data-v-23530a0d] {\n  background-color: var(--magic-success, #2dffdb);\n}", ""]);
// Exports
module.exports = exports;
